// TextEditor.js
import React from "react";
import ReactQuill from "react-quill";
import { Controller } from "react-hook-form";
import "react-quill/dist/quill.snow.css";

import "./textEditer.css"

// ✅ Quill toolbar & format config
const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"],
  ],
};

const editorFormats = [
  "header", "size",
  "bold", "italic", "underline", "strike",
  "color", "background",
  "list", "bullet",
  "align", "link"
];

const TextEditor = ({ name, label, control, rules, errors }) => (
  <div className="col-12 mb-3">
    <label className="input_lable">{label}</label>
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={rules}
      render={({ field }) => (
        <ReactQuill
          theme="snow"
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          modules={editorModules}
          formats={editorFormats}
        />
      )}
    />
    {errors?.[name] && (
      <span className="error" style={{ color: "red", fontSize: "14px" }}>
        {errors[name].message}
      </span>
    )}
  </div>
);

export default TextEditor;
